import React from "react"

//i18n
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "../../assets/images/logo.svg"
// import logo from "../../assets/images/prachay-logo.svg"
import logoLightSvg from "../../assets/images/logo-light.svg"
import logoDark from "../../assets/images/logo-dark.svg"
import { useSelector } from "react-redux"

const Sidebar = (props) => {
  const { sidebar } = useSelector((state) => state.user)

  const renderSideBar = () => {
    if (window.innerWidth <= 998) {
      return sidebar
    } else {
      return true
    }
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img
                style={{
                  marginLeft: "18px",
                  marginTop: "5px",
                }}
                src={logo}
                alt=""
                height="44"
              />
            </span>
            <span className="logo-lg">
              <img
                style={{
                  marginTop: "10px",
                }}
                src={logoDark}
                alt=""
                height="35"
              />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLightSvg} alt="" height="19" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {/* {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}  */}
          {renderSideBar() && <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

// Sidebar.propTypes = {
//   type: PropTypes.string,
// };

// const mapStatetoProps = (state) => {
//   return {
//     layout: state.Layout,
//   };
// };
// export default connect(
//   mapStatetoProps,
//   {}
// )(withRouter(withTranslation()(Sidebar)));

export default Sidebar
